import { FooterCardESpot } from '@/components/content/Footer/parts/FooterCardEspots/FooterCardEspot';
import { Grid } from '@mui/material';

export const FooterCardNavigation = () => (
	<Grid container spacing={3}>
		<FooterCardESpot emsName={'MainFooter_Navigation1'} />
		<FooterCardESpot emsName={'MainFooter_Navigation2'} />
		<FooterCardESpot emsName={'MainFooter_Navigation3'} />
		<FooterCardESpot emsName={'MainFooter_Navigation4'} />
	</Grid>
);
